import RotatingQuestionsList from './RotatingQuestionsList.container';

export default RotatingQuestionsList;
